<template>
  <!--https://kholinlabs.com/creating-a-landing-page-in-django-->

  <!-- Page Content -->
  <div
    class="whole-page"
    :style="{
      backgroundImage: 'url(' + backgroundImg + ')',
    }"
  >
    <AIChatFloat :colorTheme="colorTheme" />
    <div class="navbar-div">
      <NavbarComponent
        :user="user.all.items"
        :colorTheme="colorTheme"
        analysis="HOME"
        @eventOnUserColorTheme="onUserColorTheme"
      />
    </div>

    <div class="row f-row" style="height:20vh"></div>
    <div class="row f-row row-bckgrnd justify-content-center">
      <div class="col col-auto text-center mt-2">
        <img
          :src="logo"
          @mouseover="onMouseOver"
          @mouseout="onMouseLeave"
          height="48"
          alt=""
          style="padding: 0"
        />
        <hr class="hr-landing" />
      </div>
    </div>
    <div class="row f-row row-bckgrnd">
      <div class="col col-12 text-center">
        <span style="font-size: 1.2rem">
          Inspiring better hedging decisions
        </span>
      </div>
      <div class="col col-12 text-center mt-1 mb-3">
        Hover over images for a detailed description:
      </div>
    </div>
    <div class="row f-row row-bckgrnd justify-content-center">
      <div class="col col-auto justify-content-center text-center">
        <table
          class="table table-responsive table-borderless table-data-controls my-data-table-2 justify-content-center"
        >
          <tbody>
            <tr>
              <td
                @mouseover="hoverOverview = true"
                @mouseleave="hoverOverview = false"
              >
                <router-link
                  to="/overview"
                  tag="img"
                  :src="overview"
                  height="60"
                  alt=""
                  style="padding: 0; cursor: pointer;"
                >
                </router-link>
                <span>
                  <router-link :to="{ name: 'overview' }" class="nav-link"
                    ><button type="submit" class="btn btn-home">
                      Overview
                    </button>
                  </router-link>
                </span>
              </td>
              <td
                @mouseover="hoverMydata = true"
                @mouseleave="hoverMydata = false"
              >
                <router-link
                  to="/data"
                  tag="img"
                  :src="server"
                  height="60"
                  alt=""
                  style="padding: 0; cursor: pointer;"
                >
                </router-link>
                <span>
                  <router-link :to="{ name: 'data' }" class="nav-link"
                    ><button type="submit" class="btn btn-home">
                      Data model
                    </button>
                  </router-link>
                </span>
              </td>
              <!--              <td-->
              <!--                @mouseover="hoverMulti = true"-->
              <!--                @mouseleave="hoverMulti = false"-->
              <!--              >-->
              <!--                <router-link-->
              <!--                  to="/multi-asset"-->
              <!--                  tag="img"-->
              <!--                  :src="multiAsset"-->
              <!--                  height="60"-->
              <!--                  alt=""-->
              <!--                  style="padding: 0; cursor: pointer;"-->
              <!--                >-->
              <!--                </router-link>-->
              <!--                <span>-->
              <!--                  <router-link :to="{ name: 'multi-asset' }" class="nav-link"-->
              <!--                    ><button type="submit" class="btn btn-home">-->
              <!--                      MULTI-ASSET-->
              <!--                    </button>-->
              <!--                  </router-link>-->
              <!--                </span>-->
              <!--              </td>-->
              <td
                @mouseover="hoverAnalytics = true"
                @mouseleave="hoverAnalytics = false"
              >
                <router-link
                  to="/analytics"
                  tag="img"
                  :src="analytics_img"
                  height="60"
                  alt=""
                  style="padding: 0; cursor: pointer;"
                >
                </router-link>
                <span>
                  <router-link :to="{ name: 'analytics' }" class="nav-link"
                    ><button type="submit" class="btn btn-home">
                      Analytics
                    </button>
                  </router-link>
                </span>
              </td>
              <td
                @mouseover="hoverAdvanced = true"
                @mouseleave="hoverAdvanced = false"
              >
                <router-link
                  to="/analytics"
                  tag="img"
                  :src="advanced_img"
                  height="60"
                  alt=""
                  style="padding: 0; cursor: pointer;"
                >
                </router-link>
                <span>
                  <router-link :to="{ name: 'analytics' }" class="nav-link"
                    ><button type="submit" class="btn btn-home">
                      Advanced
                    </button>
                  </router-link>
                </span>
              </td>
              <!--              <td-->
              <!--                @mouseover="hoverCommodities = true"-->
              <!--                @mouseleave="hoverCommodities = false"-->
              <!--              >-->
              <!--                <router-link-->
              <!--                  to="/commodity"-->
              <!--                  tag="img"-->
              <!--                  :src="commodities"-->
              <!--                  height="60"-->
              <!--                  alt=""-->
              <!--                  style="padding: 0; cursor: pointer;"-->
              <!--                >-->
              <!--                </router-link>-->
              <!--                <span>-->
              <!--                  <router-link :to="{ name: 'commodity' }" class="nav-link"-->
              <!--                    ><button type="submit" class="btn btn-home">-->
              <!--                      COMMODITIES-->
              <!--                    </button>-->
              <!--                  </router-link>-->
              <!--                </span>-->
              <!--              </td>-->
              <td
                @mouseover="hoverMarkets = true"
                @mouseleave="hoverMarkets = false"
              >
                <router-link
                  to="/markets"
                  tag="img"
                  :src="markets"
                  height="60"
                  alt=""
                  style="padding: 0; cursor: pointer;"
                >
                </router-link>
                <span>
                  <router-link :to="{ name: 'markets' }" class="nav-link"
                    ><button type="submit" class="btn btn-home">Markets</button>
                  </router-link>
                </span>
              </td>
              <td
                @mouseover="hoverStrategy = true"
                @mouseleave="hoverStrategy = false"
              >
                <router-link
                  to="/optimizer"
                  tag="img"
                  :src="strategy"
                  height="60"
                  alt=""
                  style="padding: 0; cursor: pointer;"
                >
                </router-link>
                <span>
                  <router-link :to="{ name: 'optimizer' }" class="nav-link"
                    ><button type="submit" class="btn btn-home">
                      Optimizer
                    </button>
                  </router-link>
                </span>
              </td>
              <!--              <td-->
              <!--                @mouseover="hoverEducation = true"-->
              <!--                @mouseleave="hoverEducation = false"-->
              <!--              >-->
              <!--                <router-link-->
              <!--                  to="/tutorials"-->
              <!--                  tag="img"-->
              <!--                  :src="tutorial"-->
              <!--                  height="60"-->
              <!--                  alt=""-->
              <!--                  style="padding: 0; cursor: pointer;"-->
              <!--                >-->
              <!--                </router-link>-->
              <!--                <span>-->
              <!--                  <router-link :to="{ name: 'tutorials' }" class="nav-link"-->
              <!--                    ><button type="submit" class="btn btn-home">-->
              <!--                      TUTORIALS-->
              <!--                    </button>-->
              <!--                  </router-link>-->
              <!--                </span>-->
              <!--              </td>-->
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="row text-center"
      style="vertical-align: middle!important;padding: 1px 0 1px 0"
      v-if="user.all.items.first_name === ''"
    >
      <transition name="fadeAppDes">
        <div class="col col-12 home-new-user row-bckgrnd h-100">
          Welcome to
          <img
            :src="logo"
            @mouseover="onMouseOver"
            @mouseout="onMouseLeave"
            height="17.5"
            alt=""
            style="padding: 0"
          /><br />
          Please click here to go to Your
          <router-link
            :to="{ name: 'profile' }"
            class="text-info text-title text-link"
            style="padding-right: 0"
          >
            <span class="text-info text-title text-link">Profile</span>
          </router-link>
          to fill in Your personal information
        </div>
      </transition>
    </div>
    <div
      class="row text-center"
      style="vertical-align: middle!important;padding: 1px 0 1px 0"
      v-else-if="companyLen === 0"
    >
      <transition name="fadeAppDes">
        <div class="col col-12 home-new-user row-bckgrnd h-100">
          Welcome to
          <img
            :src="logo"
            @mouseover="onMouseOver"
            @mouseout="onMouseLeave"
            height="17.5"
            alt=""
            style="padding: 0"
          /><br />
          Please click here to go to
          <router-link
            :to="{ name: 'overview' }"
            class="text-info text-title text-link"
            style="padding-right: 0"
          >
            <span class="text-info text-title text-link">Overview</span>
          </router-link>
          or
          <router-link
            :to="{ name: 'data' }"
            class="text-info text-title text-link"
            style="padding-right: 0"
          >
            <span class="text-info text-title text-link">My Data</span>
          </router-link>
          to create Your Company and Portfolios
        </div>
      </transition>
    </div>
    <div
      class="row text-center justify-content-center"
      style="vertical-align: middle!important;"
    >
      <transition name="fadeAppDes">
        <div class="col col-6 home-fade-in h-100">
          <template v-if="hoverLogo"
            >Discover a cutting-edge analytical platform designed to
            revolutionize your hedging decisions:<br />
            - <strong>Control Your Data:</strong> Easily manage cash flows,
            balances, purchases, sales, and hedging strategies with My Data.<br />
            - <strong>Minimize Risk:</strong> Optimize decisions across
            Multi-Asset, Currency, and Commodities portfolios.<br />
            - <strong>Stay Ahead:</strong> Gain a clear view of market trends
            and conditions with Markets.<br />
            - <strong>Maximize Efficiency:</strong> Leverage advanced algorithms
            to perfect your hedging structures with Optimizer.</template
          >
          <template v-if="hoverOverview">
            Unlock real-time insights into your company’s exposure and hedging
            performance—effortlessly.
          </template>
          <template v-if="hoverMydata"
            >Seamlessly create, update, and download all your financial data:<br />
            - Accounts payable/receivable, projected cash flows, assets, and
            liabilities.<br />
            - Purchases, sales, and tailored hedging programs for every
            portfolio.</template
          >
          <template v-if="hoverMulti">
            Visualize your total risk across commodities and currencies.<br />
            Uncover asset correlations, reduce exposure, and seize the best
            hedging opportunities—all in one place.</template
          >
          <template v-if="hoverAnalytics">
            Gain a clear snapshot of your company’s financial health:<br />
            - <strong>Actionable Reports:</strong> Access managerial insights on
            balances, cash flows, and hedging performance.<br />
            - <strong>Track Progress:</strong> Consolidate key data by
            expiration date for smarter decision-making.<br />
            - <strong>Stay Informed:</strong> Monitor your company’s situation
            with real-time, easy-to-read summaries.
          </template>
          <template v-if="hoverAdvanced">
            Master risk with powerful, forward-looking analysis:<br />
            - <strong>Deep Insights:</strong> Assess volatility, historical
            trends, and future risk scenarios.<br />
            - <strong>Stress-Test Strategies:</strong> Run “What-If” simulations
            with real-time market data.<br />
            - <strong>Optimize Outcomes:</strong> Measure and refine your
            hedging approach with precision.
          </template>
          <template v-if="hoverMarkets">
            Stay informed with powerful market analysis:<br />
            - Quantitative reports and machine learning-driven tools deliver
            actionable insights on trends and correlations.</template
          >
          <template v-if="hoverStrategy">
            Transform insights into action:<br />
            - Design hedging structures instantly with real-time quotes.<br />
            - Optimize outcomes using simulations and advanced
            algorithms.</template
          >
          <template v-if="hoverEducation">
            Empower your team with hands-on training for commercial hedging
            success.</template
          >
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import AIChatFloat from "@/components/ai/AIChatFloat.vue";
import NavbarComponent from "../components/Navbar.vue";
import { mapState } from "vuex";
import { colorThemeChange, colorThemeVuex } from "@/_core/_helpers/_helpers";
import { saveUserPreferences } from "@/_core/data/SaveToDB";

export default {
  name: "home",
  components: {
    AIChatFloat,
    NavbarComponent,
  },
  data() {
    return {
      backgroundImg: require("@/assets/images/PTTSymmetryOscura02.jpg"),
      backgroundImgDark: require("@/assets/images/PTTSymmetryOscura02.jpg"),
      backgroundImgLight: require("@/assets/images/PTTSymmetryClara01.jpg"),
      colorTheme: true, // true = dark, else light
      commodities_blue: require("@/assets/images/commodities2_blue.svg"),
      commodities_white: require("@/assets/images/commodities2.svg"),
      commodities: require("@/assets/images/commodities2.svg"),
      companyLen: 1,
      advanced_blue: require("@/assets/images/overview_blue.png"),
      advanced_white: require("@/assets/images/overview.png"),
      advanced_img: require("@/assets/images/overview.png"),
      analytics_blue: require("@/assets/images/strategy_blue.png"),
      analytics_white: require("@/assets/images/strategy.png"),
      analytics_img: require("@/assets/images/strategy.png"),
      hoverAdvanced: false,
      hoverAnalytics: false,
      hoverEducation: false,
      hoverLogo: false,
      hoverMarkets: false,
      hoverMulti: false,
      hoverMydata: false,
      hoverOverview: false,
      hoverStrategy: false,
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo_w: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo_black: require("@/assets/images/QuanspireLogoBlack.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg"),
      markets_blue: require("@/assets/images/globe_blue.svg"),
      markets_white: require("@/assets/images/globe.svg"),
      markets: require("@/assets/images/globe.svg"),
      multiAsset_blue: require("@/assets/images/strategy_blue.png"),
      multiAsset_white: require("@/assets/images/strategy.png"),
      multiAsset: require("@/assets/images/strategy.png"),
      overview_blue: require("@/assets/images/symbol_blue.svg"),
      overview_preferences: {},
      overview_black: require("@/assets/images/symbol_gray.svg"),
      overview_white: require("@/assets/images/symbol_white.svg"),
      overview: require("@/assets/images/symbol_white.svg"),
      root: document.documentElement,
      server_blue: require("@/assets/images/server_blue.png"),
      server_white: require("@/assets/images/server.png"),
      server: require("@/assets/images/server.png"),
      strategy_blue: require("@/assets/images/multiAsset_blue.png"),
      strategy_white: require("@/assets/images/multiAsset.png"),
      strategy: require("@/assets/images/multiAsset.png"),
      tutorial_blue: require("@/assets/images/tutorial_blue.png"),
      tutorial_white: require("@/assets/images/tutorial.png"),
      tutorial: require("@/assets/images/tutorial.png"),
      userAuthenticated: "true",
    };
  },
  beforeCreate() {},
  /**
   * mapState get initial parametric states as
   * companyData, currencySpecs, countrySpecs,
   * spotData those had been gaven in localstorage in previous
   * version
   */
  created() {
    this.overview_preferences = this.$store.state.user_preferences.all.items.overview_choices;
    try {
      this.colorTheme = this.overview_preferences.color_theme;
      if (this.colorTheme === undefined) {
        this.colorTheme = true;
      }
      if (!this.colorTheme) {
        this.backgroundImg = this.backgroundImgLight;
        this.logo_white = this.logo_black;
        this.logo = this.logo_black;
        this.overview = this.overview_black;
        colorThemeChange(this.root, this.colorTheme);
        this.onUserColorTheme(this.colorTheme);
      }
    } catch (error) {
      console.log(`Error color theme ${error}`);
    }

    document.title = "Home | Quanspire";
  },
  computed: {
    ...mapState({
      companies: (state) => state.companies.all,
      currencies: (state) => state.currencies.all,
      countries: (state) => state.countries.all,
      currencies_intraday_history: (state) =>
        state.currencies_intraday_history.all,
      user: (state) => state.user,
    }),
  },
  // mounted() {},
  watch: {
    colorTheme(val) {
      if (val) {
        this.backgroundImg = this.backgroundImgDark;
        this.logo_white = this.logo_w;
        this.logo = this.logo_w;
        this.overview = this.overview_white;
      } else {
        this.backgroundImg = this.backgroundImgLight;
        this.logo_white = this.logo_black;
        this.logo = this.logo_black;
        this.overview = this.overview_black;
      }
    },
    hoverOverview(val) {
      if (val === true) {
        this.overview = this.overview_blue;
      } else {
        this.overview = this.colorTheme
          ? this.overview_white
          : this.overview_black;
      }
    },
    hoverAnalytics(val) {
      if (val === true) {
        this.analytics_img = this.analytics_blue;
      } else {
        this.analytics_img = this.analytics_white;
      }
    },
    hoverAdvanced(val) {
      if (val === true) {
        this.advanced_img = this.advanced_blue;
      } else {
        this.advanced_img = this.advanced_white;
      }
    },
    hoverCommodities(val) {
      if (val === true) {
        this.commodities = this.commodities_blue;
      } else {
        this.commodities = this.commodities_white;
      }
    },
    hoverMydata(val) {
      if (val === true) {
        this.server = this.server_blue;
      } else {
        this.server = this.server_white;
      }
    },
    hoverMulti(val) {
      if (val === true) {
        this.multiAsset = this.multiAsset_blue;
      } else {
        this.multiAsset = this.multiAsset_white;
      }
    },
    hoverStrategy(val) {
      if (val === true) {
        this.strategy = this.strategy_blue;
      } else {
        this.strategy = this.strategy_white;
      }
    },
    hoverMarkets(val) {
      if (val === true) {
        this.markets = this.markets_blue;
      } else {
        this.markets = this.markets_white;
      }
    },
    hoverEducation(val) {
      if (val === true) {
        this.tutorial = this.tutorial_blue;
      } else {
        this.tutorial = this.tutorial_white;
      }
    },
  },
  methods: {
    onUserColorTheme(val) {
      this.colorTheme = val;
      this.overview_preferences.color_theme = val;
      colorThemeVuex(this, this.colorTheme);
      saveUserPreferences(this);
      if (this.colorTheme) {
        this.backgroundImg = require("@/assets/images/PTTSymmetryOscura02.jpg");
        this.logo_white = require("@/assets/images/QuanspireLogoWhite.svg");
        this.logo = require("@/assets/images/QuanspireLogoWhite.svg");
      } else if (!this.colorTheme) {
        this.backgroundImg = require("@/assets/images/PTTSymmetryClara01.jpg");
        this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
        this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
      }
    },
    onMouseOver() {
      this.logo = this.logo_blue;
      this.hoverLogo = true;
    },
    onMouseLeave() {
      this.logo = this.logo_white;
      this.hoverLogo = false;
    },
  },
};
</script>
<style scoped>
div {
  padding: 0;
  margin: 0;
}
.logo-row {
  padding-top: 20.5vh;
}
</style>
